export default __webpack_public_path__ + "static/media/about-bgg.d8cccdbd.png";